<lib-site-setup-navbar
  [stepNumber]="StepNumberEnum.ServerInstallationChecklist"
  class="w-full"
  [loggedInUser]="vm().currentUser"
  [isNewModalDesign]="true"
  [hasBackButton]="false"
  [hasUserProfile]="false"
></lib-site-setup-navbar>
<div
  class="mt-2 font-poppins text-[24px] font-medium leading-[34px] tracking-[-0.7px] text-[#595959] xs:text-[30px] xs:leading-[45px]"
>
  <span>{{ 'site_setup_checklist_title_part1' | translate }}</span
  ><br /><span class="text-background border-0 border-r-2 border-solid border-primary-blue">{{
    pmsName()
      ? ('site_setup_checklist_title_part2' | translate: { input1: pmsName() })
      : ('site_setup_checklist_title_part2_no_pms' | translate)
  }}</span>
</div>
<div class="mt-5 flex flex-col gap-5">
  <h4 class="typo-h4-light font-poppins font-light leading-[24px] text-text-light">
    {{ 'site_setup_checklist_subtitle' | translate }}
  </h4>
  <div class="typo-h4-light flex gap-2 pl-2 font-poppins font-light leading-[24px] text-text-light">
    <span>1.</span>
    <span
      [innerHTML]="
        (pmsName()
          ? ('site_setup_checklist_new_step1' | translate: { input1: pmsName() })
          : ('site_setup_checklist_new_step1_no_pms' | translate)
        )
          | markdown
          | async
      "
    ></span>
  </div>
  <div class="typo-h4-light flex gap-2 pl-2 font-poppins font-light leading-[24px] text-text-light">
    <span>2.</span>
    <span [innerHTML]="'site_setup_checklist_new_step2' | translate | markdown | async"></span>
  </div>
  <div class="typo-h4-light flex gap-2 pl-2 font-poppins font-light leading-[24px] text-text-light">
    <span>3.</span>
    <span [innerHTML]="'site_setup_checklist_new_step3' | translate | markdown | async"></span>
  </div>
</div>

<div class="mt-10 flex flex-col-reverse gap-3 xs:flex-row">
  <button class="btn-secondary flex h-10 w-full items-center justify-center xs:w-[172px]" type="button" (click)="comeBackLater()">
    {{ 'site_setup_checklist_continue_later' | translate }}
  </button>
  <button class="btn-primary flex h-10 w-full items-center justify-center" type="button" (click)="ready()">
    {{ 'site_setup_checklist_continue' | translate }}
  </button>
</div>
